"use strict";

var React = require('react/addons'),
    ReactRouter = require('react-router'),
    DocumentTitle = require('react-document-title'),
    cx = require('classnames'),
    BS = require('react-bootstrap'),
    Constants = require('../../constants'),
    ToolboxSidebar = require('./Sidebar'),
    Header = require('./Header'),
    Footer = require('./Footer'),
    Cmp = require('../../components'),
    CurrentUser = require('../../shared/CurrentUser'),
    EmailTemplates = require('../../collections/EmailTemplates'),
    Validation = require('../../partials/validation'),
    $ = require('jquery'),
    Link = require('../../components/Link'),
    Clipboard = require('../../external/clipboard'),
    toastr = require('toastr');

var ToolboxPersonalizedEmail = React.createClass({displayName: "ToolboxPersonalizedEmail",

    contextTypes: {
        router: React.PropTypes.func
    },

    updateState: function(props) {
        var state = this.state || {},
            query;

        props = props || this.props;

        query = this.context.router.getCurrentQuery();

        return {
            id: query.id,
            projectId: props.project.id,
            emailSent : query.id !== state.id || !props.project || props.project.id !== this.props.project.id ? false : state.emailSent,
            emailModel: query.id ? props.collection.get(query.id) : undefined,
            previewHtml: query.id !== state.id ? undefined : state.previewHtml
        };
    },

    getInitialState: function() {
        return this.updateState();
    },

    /**
     * This is to ensure that when subroutes transistion they trigger recheck router state and render
     */
    componentWillReceiveProps: function(newProps) {
        var state = this.updateState(newProps);



        this.setState(state);
    },

    getDefaultProps: function() {
        return {
            collection: new EmailTemplates()
        };
    },

    componentWillUpdate: function(nextProps, nextState) {
        if(nextState.id && nextState.projectId && (nextState.id !== this.state.id || nextState.projectId !== this.state.projectId)) {
            this.loadPreview(nextState);
        }
    },

    componentWillMount: function() {
        if(this.state.id && this.props.project.id) {
            this.loadPreview();
        }
    },

    loadPreview: function(state) {
        var me = this;

        state = state || this.state;

        me.getPreview(state.id, me.props.project.id);
    },

    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            data = props.project.toJSON(),
            query = {
                id: state.id
            },
            emailModel = state.emailModel,
            fieldAttrs = {
                labelClassName: 'col-md-3',
                type: 'text',
                trigger: "onChange",
                wrapperClassName: 'col-md-9'
            },
            title = props.title + ' - Personalized Email';

        return (
             React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: title}), 
                React.createElement(Header, {project: props.project, builder: props.builder}), 
                React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        React.createElement(ToolboxSidebar, {project: props.project, showContactForm: true}), 
                        state.emailSent ? (
                            React.createElement("div", {className: "col-sm-9"}, 
                                React.createElement("div", {className: "margin-bottom-20"}, 
                                    React.createElement("h1", null, "Agent Branded Emails: ", React.createElement("span", {className: "blue-text"}, emailModel.get('name') + ' Email')), 
                                    React.createElement("p", null, "This is a personalized and branded email for you to use. The email has your contact information. Send the email to yourself and forward to your buyers. You can also copy the email content and paste it in your own email program to send out to your buyers.")
                                ), 
                                React.createElement(BS.Alert, {bsStyle: "success"}, 
                                    "Success! Your Agent Branded Email has been sent to you! If you do not see the email in your inbox, it may be in your junk or spam folder."
                                )
                            )
                        ) : emailModel ? (
                            React.createElement("div", {className: "col-sm-9"}, 
                                React.createElement("div", {className: "margin-bottom-20"}, 
                                    React.createElement("h1", null, "Agent Branded Emails: ", React.createElement("span", {className: "blue-text"}, emailModel.get('name') + ' Email')), 
                                    React.createElement("p", null, "This is a personalized and branded email for you to use. The email has your contact information. Send the email to yourself and forward to your buyers. You can also copy the email content and paste it in your own email program to send out to your buyers."), 
                                    React.createElement("a", {href: "#", className: "btn-u btn-u-ultra-narrow btn-u-blue", onClick: me.previewEmail.bind(null, emailModel), alt: "Preview Email", title: "Preview Email"}, "Preview Email")
                                ), 

                                React.createElement("div", {className: "margin-bottom-20"}, 
                                    React.createElement("h3", {className: "orange-text"}, "Option 1: Send the email yourself."), 
                                    React.createElement("p", null, "Send the email to yourself and forward to your list of buyers. Enter your email address below to send the email to yourself.")
                                ), 

                                React.createElement(Validation.Form, {ref: "form", model: emailModel, onSubmit: this.onSubmit, validateOnLoad: false}, 
                                    React.createElement(Validation.Input, React.__spread({},  fieldAttrs, {name: "email", label: "Your Email Address:"})), 
                                    React.createElement(BS.ButtonToolbar, {className: "no-margin"}, 
                                        React.createElement(Cmp.Button.Save, {className: "pull-right", label: "Send"})
                                    )
                                ), 

                                React.createElement("div", {className: "margin-bottom-20"}, 
                                    React.createElement("h3", {className: "orange-text"}, "Option 2: Do you use an email marketing service?"), 
                                    React.createElement("img", {src: Constants.imageRoot + 'toolbox/EmailLogos.png', className: "img-responsive"}), 
                                    React.createElement("p", null, "Do you use an email marketing service like the ones listed above to email your buyers? Copy the HTML code below and paste it into your email."), 
                                    Constants.canClipboardCopy && (
                                        React.createElement("div", {className: "btn-u btn-u-ultra-narrow btn-u-orange margin-bottom-10", onClick: this.copyToClipboard}, "Copy Code to Clipboard")
                                    ), 
                                    React.createElement(BS.Input, {readOnly: true, type: "textarea", ref: "textarea", rows: "10", value: this.state.previewHtml, onFocus: this.selectText})
                                )

                            )
                        ) : (
                            React.createElement("div", {className: "col-sm-9"}, 
                                React.createElement("div", {className: "margin-bottom-20"}, 
                                    React.createElement("h1", null, "Agent Branded Emails"), 
                                    React.createElement("p", null, "Agent Branded Emails are designed to make it easy for agents to market this community to their buyers through email. These pre-created emails contain information about the community and are branded for the agent.")
                                    /* <h3 className="orange-text">Start by selected a template.</h3> */
                                ), 
                                React.createElement("div", null, 
                                    React.createElement("ul", {className: "inline-list"}, 
                                        props.collection.map(function(model) {
                                            var linkQuery = _.defaults({
                                                    id: model.id
                                                }, query),
                                                name = model.get('name');

                                            return (
                                                React.createElement("li", {key: model.id, className: "margin-bottom-10"}, 
                                                    React.createElement("h5", null, name + ' Email'), 
                                                    React.createElement("a", {href: "#", onClick: me.previewEmail.bind(null, model), alt: "Preview Email", title: "Preview Email"}, React.createElement("img", {className: "margin-bottom-10", src: model.get('image')})), 
                                                    React.createElement("br", null), 
                                                    React.createElement(Link, {to: "PersonalizedEmail", query: linkQuery, className: "pull-right btn-u btn-u-ultra-narrow btn-u-orange"}, "Use this Email")
                                                )
                                            );
                                        })
                                    )
                                )
                            )
                        )
                    ), 
                    React.createElement(Footer, {trackerId: "agent-toolbox-personalized-email"})
                ), 
                React.createElement(BS.Modal, {className: "modal-preview modal-md", show: state.showPreview && state.previewHtml, onHide: this.closePreviewDialog}, 
                    React.createElement(BS.Modal.Body, {className: ""}, 
                        React.createElement("div", {dangerouslySetInnerHTML: {__html: state.previewHtml}})
                    )
                )
            )
        );
    },

    previewEmail: function(model, e) {
        var me = this,
            props = me.props;

        if(e) {
            e.preventDefault();
        }

        me.getPreview(model.id, me.props.project.id).then(function(response) {
            me.setState({
                showPreview: true,
            });
            window.scrollTo(0, 0);
        });
    },

    getPreview: function(templateId, projectId) {
        var me = this;
        
        return $.ajax({
            url: Constants.restPath + '/agents/brochure',
            data: {
                format: 'html',
                listingId: projectId,
                template: templateId
            }
        }).then(function(response) {
            response = response.trim().replace(/(\n)/g, '');
            response = response.replace(/<div id="agent_brochure_email_instructions">(.*?)<\/div>/ig, '');
            me.setState({
                previewHtml: response
            });
        });
    },

    closePreviewDialog: function() {
        this.setState({
            showPreview: false,
            previewHtml: undefined
        });
    },

    copyToClipboard: function() {
        Clipboard.copy(this.state.previewHtml);
        toastr.success('Copied to Clipboard!');
    },

    // http://stackoverflow.com/questions/5797539/jquery-select-all-text-from-a-textarea
    selectText: function(e) {
        var textarea = e.target;

        $(textarea).select();

        // Work around Chrome's little problem
        textarea.onmouseup = function() {
            // Prevent further mouseup intervention
            textarea.onmouseup = null;
            return false;
        };
    },

    onSubmit: function() {
        var me = this,
            props = this.props,
            state = this.state,
            values = me.refs.form.getValues(),
            email = values.email;

        $.ajax({
            url: state.emailModel.getPreviewURL({
                format: 'email',
                id: state.id,
                listingId: props.project.id,
                data: {
                    email: email
                }
            })
        }).then(function(response) {
            me.setState(function() {
                return {
                    emailSent: true
                }
            });
            window.scrollTo(0, 0);
        });
    }
});
module.exports = ToolboxPersonalizedEmail;
